export const DOG_BREEDS = [
  'Goldador',
  'Kuvasz',
  'Affenpinscher',
  'Affen Terrier',
  'Africanis',
  'Akbash Dog',
  'Akita',
  'Akita Shepherd',
  'American Bull Mastiff',
  'Bearded Collie',
  'Cairn Terrier',
  'English Bulldog',
  'Field Spaniel',
  'Karakachan',
  'Silky Terrier',
  'Afghan Hound',
  'Aidi',
  'Alaskan Husky',
  'Alaskan Klee Kai',
  'Alpine Dachsbracke',
  'American Boston Bull Terrier',
  'American Bully',
  'American Village Dog',
  'Andalusian Podenco',
  'Ausky',
  'Australian Retriever',
  'Bassador',
  'Yorkipoo',
  'American English Coonhound',
  'American Eskimo Dog',
  'American French Bulldog',
  'American Hairless Terrier',
  'American Leopard Hound',
  'American Mastiff',
  'American Staffordshire Terrier',
  'American Water Spaniel',
  'American White Shepherd',
  'Anatolian Pyrenees',
  'Biewer',
  'Boxador',
  'Chorkie',
  'Anatolian Shepherd',
  'Appenzeller Sennenhund',
  'Ariegeois',
  'Arubian Cunucu Dog',
  'Aussie-Corgi',
  'Aussiedor',
  'Aussie Siberian',
  'Australian Labradoodle',
  'Australian Stumpy Tail Cattle Dog',
  'Australian Terrier',
  'Australian Yorkshire Terrier',
  'Austrian Pinscher',
  'Cattle Collie Dog',
  'Azawakh',
  'Bagle Hound',
  'Barbet',
  'Basenji',
  'Basset Artesien Normand',
  'Basset Hound',
  'Beagle',
  'Bedlington Terrier',
  'Belgian Laekenois',
  'Belgian Malinois',
  'Berger Picard',
  'Chinese Crestese',
  'Deutscher Wachtelhund',
  'English Pointer',
  'Beabull',
  'Bernese Mountain Dog',
  'Bichon Frise',
  'Bichon/Yorkie',
  'Bich-poo',
  'Billy',
  'Black and Tan Coonhound',
  'Black Mouth Cur',
  'Black Norwegian Elkhound',
  'Black Russian Terrier',
  'Braque Francais Pyrenean',
  'Englian Mastiff',
  'German Shorthaired Lab',
  'Wirehaired Vizsla',
  'Airedale Terrier',
  'American Foxhound',
  'Belgian Tervuren',
  'Bloodhound',
  'Chesapeake Bay Retriever',
  'Flat-Coated Retriever',
  'Golden Pyrenees',
  'Great Bernese',
  'Griffon Nivernais',
  'Papillon',
  'Standard Schnauzer',
  'Working Kelpie',
  'White Shepherd',
  'Alaskan Malamute',
  'Anatolian Shepherd Dog',
  'Austrian Black and Tan Hound',
  'Basset Fauve de Bretagne',
  'Blue Picardy Spaniel',
  'Chinese Crested',
  'Dandie Dinmont Terrier',
  'Ibizan Hound',
  'Lakeland Terrier',
  'Norfolk Terrier',
  'Pekingese',
  'Shih Tzu',
  'Tibetan Spaniel',
  'Wire Fox Terrier',
  'Barbado da Terceira',
  'Briquet Griffon Vendeen',
  'Beagle-Harrier',
  'Beaglier',
  'Beauceron',
  'Belgian Shepherd Laekenois',
  'Blue Lacy',
  'Bolognese',
  'Brottweiler',
  'Carolina Dog',
  'Caucasian Ovcharka',
  'Drever',
  'Dunker',
  'English Shepherd',
  'Eurasier',
  'French Spaniel',
  'Bavarian Mountain Scent Hound ',
  'Norwegian Lundehund',
  'Bluetick Coonhound',
  'Boerboel',
  'Glen of Imaal Terrier',
  'Greenland Dog',
  'Irish Red and White Setter',
  'King Shepherd',
  'Lancashire Heeler',
  'Lucas Terrier',
  'Mudi',
  'Neapolitan Mastiff',
  'Nederlandse Kooikerhondje',
  'Patterdale Terrier',
  'Perro de Presa Mallorquin',
  'Bergamasco Sheepdog',
  'Bohemian Shepherd',
  'Borador',
  'Chug',
  'Pyrenean Shepherd',
  'Shikoku dog',
  'Shiloh Shepherd dog',
  'Silken Windhound',
  'Sloughi',
  'Slovensky Cuvac',
  'South Russian Ovcharka',
  'Stabyhoun',
  'Transylvanian Hound',
  'Border-Aussie',
  'Border Beagle',
  'Border Collie Pyrenees',
  'Border Terrier',
  'Bordoodle',
  'Borzoi',
  'Bulldog',
  'Goberian',
  'Golden Cocker Retriever',
  'Halden Hound',
  'Lab Pei',
  'Labrottie',
  'Pomchi',
  'Siberian Husky',
  'Boston Terrier',
  'Bouvier des Ardennes',
  'Bouvier des Flandres',
  'Boxer',
  'Bracco Italiano',
  "Braque d'Auvergne",
  'Braque du Bourbonnais',
  'Briard',
  'Brittany',
  'Brussels Griffon',
  'Irish Doodle',
  'Labradane',
  'Labraheeler',
  'Bull-Boxer',
  'Bullboxer Pit',
  'Bullmastiff',
  'Toy Poodle',
  'Bull Terrier',
  'Canaan Dog',
  'Canadian Eskimo Dog',
  'Cane Corso',
  'Cardigan Welsh Corgi',
  'Catahoula Bulldog',
  'Caucasian Shepherd Dog',
  'Cavachon',
  'Cavalier King Charles Spaniel',
  'Newfypoo',
  'Central Asian Shepherd Dog',
  'Cesky Fousek',
  'Cesky Terrier',
  'Chart Polski',
  'Chinook',
  'Chipit',
  'Chiweenie',
  'Chow Chow',
  'Chow Shepherd',
  'Chusky',
  'Cirneco dell’Etna',
  'Clumber Spaniel',
  'Cockalier',
  'Cockapoo',
  'Roman Rottweiler',
  'Collie',
  'Corgi Basset',
  'Corgi Cattle Dog',
  'Corgidor',
  'Coton De Tulear',
  'Croatian Sheepdog',
  'Curly-Coated Retriever',
  'Czechoslovakian Vlcak',
  'Czechoslovakian Wolfdog',
  'Dachshund',
  'Dalmatian',
  'Danish-Swedish Farmdog',
  'Deutsche Bracke',
  'Romanian Mioritic Shepherd Dog',
  'Shikoku',
  'American Pit Bull Terrier',
  'Australian Cattle Dog',
  'Australian Shepherd',
  'Border Collie',
  'Dingo',
  'Doberman Pinscher',
  'Doberman Shepherd',
  'Drentsche Patrijshond',
  'Dutch Shepherd Dog',
  'Dutch Smoushond',
  'East Asian Village Dog',
  'Other',
  'Teddy Roosevelt Terrier',
  'White German Shepherd',
  'American Bulldog',
  'Bernedoodle',
  'Catahoula Leopard Dog',
  'Chihuahua',
  'German Wirehaired Pointer',
  'Great Pyrenees',
  'Labradoodle',
  'Mastiff',
  'Newfoundland',
  'Pit Bull',
  'Soft Coated Wheaten Terrier',
  'Treeing Walker Coonhound',
  'Whippet',
  'Australian Kelpie',
  'Boykin Spaniel',
  'Cavapoo',
  'Double Doodle',
  'Giant Schnauzer',
  'Italian Greyhound',
  'Keeshond',
  'Lagotto Romagnolo',
  'Norwegian Elkhound',
  'Norwich Terrier',
  'Schnoodle',
  'Slovensky Kopov',
  'Texas Heeler',
  'Xoloitzcuintli',
  'Aussiedoodle',
  'Belgian Sheepdog',
  'Broholmer',
  'Bullypit',
  'Catalonian Sheepdog',
  'Chinese Shar-Pei',
  'Cocker Spaniel',
  'Dogo Argentino',
  'Dogue de Bordeaux',
  'English Cocker Spaniel',
  'English Foxhound',
  'Löwchen',
  'Native American Indian Dog',
  'Slovakian Wirehaired Pointer',
  'Tosa',
  'English Setter',
  'English Springer Spaniel',
  'English Toy Spaniel',
  'Entlebucher Mountain Dog',
  'Estrela Mountain Dog',
  'Feist',
  'Finnish Hound',
  'Finnish Lapphund',
  'Finnish Spitz',
  'Foxy Rat Terrier',
  'French Bulldog',
  'Gerberian Shepsky',
  'German Australian Shepherd',
  'German Longhaired Pointer',
  'German Malinois',
  'German Pinscher',
  'German Shepherd Dog',
  'German Sheprador',
  'German Shorthaired Pointer',
  'German Spitz',
  'Golden Border Retriever',
  'Goldendoodle',
  'Golden Retriever',
  'Golden Shepherd',
  'Gordon Setter',
  'Grand Anglo-Francais Blanc et Noir',
  'Grand Anglo-Francais Tricolore',
  'Grand Basset Griffon Vendeen',
  'Grand Bleu de Gascogne',
  'Great Dane',
  'Greater Swiss Mountain Dog',
  'Great Pyredane',
  'Greyhound',
  'Griffon bleu de Gascogne',
  'Griffon Fauve de Bretagne',
  'Hamiltonstovare',
  'Hanoverian Scenthound',
  'Harrier',
  'Havanese',
  'Hokkaido',
  'Hovawart',
  'Hungarian Greyhound',
  'Huskita',
  'Husky Jack',
  'Icelandic Sheepdog',
  'Irish Setter',
  'Irish Terrier',
  'Irish Water Spaniel',
  'Irish Wolfhound',
  'Jack Chi',
  'Jack-Rat Terrier',
  'Jack Russell Terrier',
  'Jagdterrier',
  'Japanese Akitainu',
  'Japanese Chin',
  'Japanese Spitz',
  'Japanese Terrier',
  'Jindo',
  'Kai Ken',
  'Kangal Dog',
  'Karelian Bear Dog',
  'Karst Shepherd',
  'Kerry Blue Terrier',
  'Kishu Ken',
  'Komondor',
  'Kromfohrlander',
  'Labbe',
  'Labloodhound',
  'Lab-Pointer',
  'Labrabull',
  'Labrador Husky',
  'Labrador Retriever',
  'Labsky',
  'Labstaff',
  'Lapponian Herder',
  'Large Munsterlander',
  'Leonberger',
  'Lhasa Apso',
  'Lurcher',
  'Majorca Shepherd Dog',
  'Mal-Shi',
  'Maltese',
  'Maltipoo',
  'Manchester Terrier',
  'Maremma Sheepdog',
  'Mastador',
  'McNab',
  'Miniature American Shepherd',
  'Miniature Australian Shepherd',
  'Miniature Bull Terrier',
  'Miniature Pinscher',
  'Miniature Poodle',
  'Miniature Schnauzer',
  'Miniature Shar Pei',
  'Morkie',
  'Mountain Cur',
  'Mountain Feist',
  'Mountain View Cur',
  'Norrbottenspets',
  'Norwegian Buhund',
  'Nova Scotia Duck Tolling Retriever',
  'Olde English Bulldogge',
  'Old English Mastiff',
  'Old English Sheepdog',
  'Otterhound',
  'Parson Russell Terrier',
  'Patterland Terrier',
  'Pembroke Welsh Corgi',
  'Perro de Presa Canario',
  'Peruvian Inca Orchid',
  'Petit Basset Griffon Vendéen',
  'Pharaoh Hound',
  'Picardy Spaniel',
  'Pitsky',
  'Pitt Plott',
  'Plott Hound',
  'Pocket Pitbull',
  'Pointer',
  'Polish Hound',
  'Polish Lowland Sheepdog',
  'Polish Tatra Sheepdog',
  'Pomeranian',
  'Pomsky',
  'Poodle',
  'Porcelaine',
  'Portuguese Podengo',
  'Portuguese Podengo Pequeno',
  'Portuguese Pointer',
  'Portuguese Sheepdog',
  'Portuguese Water Dog',
  'Pudelpointer',
  'Pug',
  'Saint Berdoodle',
  'Puggle',
  'Puli',
  'Pumi',
  'Pyrador',
  'Pyredoodle',
  'Pyrenean Mastiff',
  'Rafeiro do Alentejo',
  'Rat Terrier',
  'Redbone Coonhound',
  'Rhodesian Ridgeback',
  'Romanian Carpathian Shepherd',
  'Rottweiler',
  'Russell Terrier',
  'Russian Toy',
  'Russian Tsvetnaya Bolonka',
  'Saint Bernard',
  'Saluki',
  'Samoyed',
  'Sarplaninac',
  'Schapendoes',
  'Schiller Hound',
  'Schipperke',
  'Scotch Collie',
  'Scottish Deerhound',
  'Scottish Terrier',
  'Sealyham Terrier',
  'Segugio Italiano',
  'Seppala Siberian Sleddog',
  'Serbian Hound',
  'Serbian Tricolour Hound',
  'Sharberian Husky',
  'Sheepadoodle',
  'Sheltie Shepherd',
  'Shepadoodle',
  'Shepherd Chow',
  'Sheprador',
  'Shetland Sheepdog',
  'Shiba Inu',
  'Shichon',
  'Shihpoo',
  'Shorkie Tzu',
  'Skilky Terrier',
  'Skye Terrier',
  'Smaland Hound',
  'Small Munsterlander',
  'Smooth and Wire Fox Terrier',
  'Smooth Fox Terrier',
  'Spanish Greyhound',
  'Spanish Hound',
  'Spanish Mastiff',
  'Spanish Water Dog',
  'Spinone Italiano',
  'Springerdoodle',
  'Staffordshire Bull Terrier',
  'Staffy Bull Pit',
  'Sussex Spaniel',
  'Swedish Lapphund',
  'Swedish Vallhund',
  'Swiss Hound',
  'Taco Terrier',
  'Taiwan Dog',
  'Tamaskan Dog',
  'Thai Ridgeback',
  'Tibetan Mastiff',
  'Tibetan Terrier',
  'Titan Terrier',
  'Tornjak',
  'Toxirn',
  'Toy Fox Terrier',
  'Treeing Cur',
  'Treeing Tennessee Brindle',
  'Vizsla',
  'Volpino Italiano',
  'Weimaraner',
  'Welsh Springer Spaniel',
  'Welsh Terrier',
  'West Highland White Terrier',
  'West Siberian Laika',
  'Wetterhoun',
  'Whoodle',
  'Wirehaired Pointing Griffon',
  'Wire Hair Snauzer',
  'Wolfdog',
  'Yakutian Laika',
  'Yorkshire Terrier',
];

export const CAT_BREEDS = [
  'Abyssinian',
  'American Bobtail',
  'American Shorthair',
  'American Wirehair',
  'Australian Mist',
  'Balinese- Javanese',
  'Bengal',
  'Birman',
  'Bombay',
  'British Shorthair',
  'Burmese',
  'Chartreux',
  'Chausie',
  'Cornish Rex',
  'Cymric',
  'Devon Rex',
  'Domestic Longhair (DLH)',
  'Domestic Mediumhair (DMH)',
  'Domestic Shorthair (DSH)',
  'Donskoy',
  'Egyptian Mau',
  'European Burmese',
  'European Shorthair',
  'Korat',
  'Maine Coon',
  'Manx',
  'Minuet',
  'Nebelung',
  'Norwegian Forest',
  'Ocicat',
  'Persian',
  'Peterbald',
  'Pixiebob',
  'Ragamuffin',
  'Ragdoll',
  'Russian Blue',
  'Savannah',
  'Scottish Fold',
  'Scottish Straight',
  'Selkirk Rex',
  'Siamese',
  'Siberian',
  'Singapura',
  'Snowshoe',
  'Somali',
  'Sphynx',
  'Thai',
  'Tonkinese',
  'Other',
];
